import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class ContratistaService {

  id: any
  contratistas: any = []

  constructor() { }

  getAllContratistas() {
    return gql`
      query getAllContratistas {
          contratistas(sort: "createdAt:DESC") {
            id
            nombreComercial
            cif
            estado
            customID
            documentos{
              tipo
              estado
            }
            contactoResponsable {
              nombre
              mail
            }
            createdAt
            centros{
              estado
              documentos{
                tipo
                estado
              }
            }
              
            
          }
        }
    `;
  }

  getAllContratistasYellow() {
    return gql`
      query getAllContratistas {
          contratistas(
            where: {
              estado: "amarillo"
            }) 
            {
            id
            nombreComercial
            cif
            estado
            customID
            documentos{
              tipo
              estado
            }
            contactoResponsable {
              nombre
              mail
            }
            createdAt
            centros{
              estado
              documentos{
                tipo
                estado
              }
            }
              
            
          }
        }
    `;
  }

  getAllContratistasGreen() {
    return gql`
      query getAllContratistas {
          contratistas(
            where: {
              estado: "verde"
            })
             {
            id
            nombreComercial
            cif
            estado
            customID
            documentos{
              tipo
              estado
            }
            contactoResponsable {
              nombre
              mail
            }
            createdAt
            centros{
              estado
              documentos{
                tipo
                estado
              }
            }
              
            
          }
        }
    `;
  }

  getAllContratistasRed() {
    return gql`
      query getAllContratistas {
          contratistas(
            where: {
              estado: "rojo"
            }) 
            {
            id
            nombreComercial
            cif
            estado
            customID
            documentos{
              tipo
              estado
            }
            contactoResponsable {
              nombre
              mail
            }
            createdAt
            centros{
              estado
              documentos{
                tipo
                estado
              }
            }
              
            
          }
        }
    `;
  }

  getAllContratistasDoughnout() {
    return gql`
      query getAllContratistas {
          contratistas(sort: "createdAt:DESC") {
            estado
            id
            centros{
              estado
              documentos {
                estado
                tipo	
              }
              gestors {
                id
                estado
                documentos {
                  estado
                  tipo
                }
              }
              transportistas {
                id
                estado
                documentos {
                  estado
                  tipo	
                }
              }
            }
            documentos{
              estado
              tipo
            }             
          }
        }
    `;
  }

  getContratistasCif() {
    return gql`
      query getContratistasCif {
          contratistas {
            cif
            id
            contactoResponsable {
              nombre
              mail
            }  
            clientes {
              id
            }      
          }
        }
    `;
  }

  getContratistaById() {
    return gql`
      query getContratistaById($id: ID!) {
          contratista(id: $id) {
            id
            numeroInvitacion
            nombreComercial
            razonSocial
            firstTime
            cif
            seguridadSocial
            hacienda
            nuevoSeguridadSocial
            nuevoHacienda
            logo
            licenciasPagadas
            xtensaBasica
            identificadorCO
            customID
            facturas{
              id
              estado
            }
            direccion {
              tipoVia
              nombre
              provincia
              ccaa
              codigoPostal
              letra
              numero
              localidad
              pta
            }
            contactoResponsable {
              nombre
              mail
              cargo
            }
            actividad
            contacto {
              nombre
              cargo
              mail
            }
            clientes {
              nombreComercial
            }
            gestores {
              nombre
            }
            transportistas {
              nombre
            }
            comentariosSeguridadSocial {
              comentario
              fecha
              causa
            }
            comentariosHacienda {
              comentario
              fecha
              causa
            }
            documentos {
              id
              seguridadSocial
              hacienda
            }
            centros{
              id
              documentos{
                id
                tipo
                enFecha
                caducado
                proximoCaduca
              }
            }
          }
        }
    `;
  }



  addContratista() {
    return gql`
      mutation createContratista($input: createContratistaInput!) {
      createContratista(input: $input) {
        contratista {
          id
          contactoResponsable {
            mail
          }
          xtensaBasica
        }
      }
    }
    `;
  }

  updateContratista() {
    return gql`
      mutation updateContratista($input: updateContratistaInput!) {
        updateContratista(input: $input) {
          contratista {
            id
            comentariosSeguridadSocial {
              comentario
              fecha
              causa
            }
            comentariosHacienda {
              comentario
              fecha
              causa
            }
          }
        }
      }
    `;
  }

  updateContratistaByTransportista() {
    return gql`
      mutation updateContratista($input: updateContratistaInput!) {
        updateContratista(input: $input) {
          contratista {
            id
            transportistas {
              id
            }            
          }
        }
      }
    `;
  }

  updateContratistaByGestor() {
    return gql`
      mutation updateContratista($input: updateContratistaInput!) {
        updateContratista(input: $input) {
          contratista {
            id
            gestores {
              id
            }            
          }
        }
      }
    `;
  }

  deleteContratista() {
    return gql`
      mutation deleteContratista($input: deleteContratistaInput!) {
        deleteContratista(input: $input) {
          contratista {
            id
          }
        }
      }
    `;
  }

  getCentrosByContratista() {
    return gql`
      query getCentrosByContratista($id: ID!){
        contratista(id: $id){
          centros {
          id
          nombre
          estado
          customID
          clientes {
            nombreComercial
          }
          contactoResponsable {
            nombre
            mail
          }
          contacto {
            mail
          }
          direccion {
            tipoVia
            nombre
            numero
            ccaa
          }
          documentos {
            id
            tipo
            enFecha
            caducado
            proximoCaduca
            estado
          }
          gestors{
            id
            estado
            documentos{
              tipo 
              estado
            }
          }
          transportistas{
            id
            estado
            documentos{
              tipo
              estado
            }
          }
        }
        }
      }
    `;
  }

  getCentrosByContratistaDoughnout() {
    return gql`
      query getCentrosByContratista($id: ID!){
        contratista(id: $id){
          centros {
          id
          estado
          documentos {
            tipo
            estado
          }
          gestors{
            id
            estado
            documentos {
              tipo
              estado
            }
          }
          transportistas{
            id
            estado
            documentos {
              tipo
              estado
            }
          }
        }
        }
      }
    `;
  }

  getCentrosByContratistaTablas() {
    return gql`
      query getCentrosByContratista($id: ID!){
        contratista(id: $id){
          licenciasPagadas
          centros {
          id
          IdCentro
          nombre
          nima
          resPeligrosos
          GPResPeligrosos
    
          clientes {
            nombreComercial
            id
          }
          contactoResponsable {
            nombre
            mail
  
          }
          
          direccion {
            tipoVia
            nombre
            numero
            ccaa
            pta
            letra
            provincia
            codigoPostal
          }

          gestors {
            nombre
          }

          transportistas {
            nombre
          }
          
        }
        }
      }
    `;
  }

  getCentrosGreenContratista() {
    return gql`
    query getCentrosByContratista($id: ID!){
      contratista(id: $id){
          centros (
            where: {
              estado: "verde"
            }
          ){
            id
            nombre
          clientes {
            nombreComercial
            id
          }
          contactoResponsable {
            nombre
  
          }
          
          direccion {
            tipoVia
            nombre
            numero
            ccaa
          }
          
          }
        }
      }
    `;
  }


  getCentrosYellowContratista() {
    return gql`
    query getCentrosByContratista($id: ID!){
      contratista(id: $id){
          centros (
            where: {
              estado: "amarillo"
            }
          ){
            id
            nombre
          clientes {
            nombreComercial
            id
          }
          contactoResponsable {
            nombre
  
          }
          
          direccion {
            tipoVia
            nombre
            numero
            ccaa
          }
          
          }
        }
      }
    `;
  }

  getCentrosRedContratista() {
    return gql`
    query getCentrosByContratista($id: ID!){
      contratista(id: $id){
          centros (
            where: {
              estado: "rojo"
            }
          ){
            id
            nombre
          clientes {
            nombreComercial
            id
          }
          contactoResponsable {
            nombre
  
          }
          
          direccion {
            tipoVia
            nombre
            numero
            ccaa
          }
          
          }
        }
      }
    `;
  }


  getClientesByContratista() {
    return gql`
      query getClientesByContratista($id: ID!){
        contratista(id: $id){
          clientes {
            id
            nombreComercial
            cif
            contactoResponsable {
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
            }
            gestores{
              id
            }
            transportistas{
              id
            }
            licencias{
              IDLicencia
              licenciaActiva
            }
          }
        }
      }
    `;
  }

  getClientesGreenContratista() {
    return gql`
      query getClientesByContratista($id: ID!){
        contratista(id: $id){
          clientes (
            where: {
              estado: "verde"
            }
          ) {
           
            id
            nombreComercial
            cif
            contactoResponsable {
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
            }
            gestores{
              id
            }
            transportistas{
              id
            }
          }
        }
      }
    `;
  }

  getClientesYellowContratista() {
    return gql`
      query getClientesByContratista($id: ID!){
        contratista(id: $id){
          clientes (
            where: {
              estado: "amarillo"
            }
          ){
            
            id
            nombreComercial
            cif
            contactoResponsable {
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
            }
            gestores{
              id
            }
            transportistas{
              id
            }
          }
        }
      }
    `;
  }

  getClientesRedContratista() {
    return gql`
      query getClientesByContratista($id: ID!){
        contratista(id: $id){
          clientes (
            where: {
              estado: "rojo"
            }
          ){
            
            id
            nombreComercial
            cif
            contactoResponsable {
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
            }
            gestores{
              id
            }
            transportistas{
              id
            }
          }
        }
      }
    `;
  }



  getClientesByContratistaDoughnout() {
    return gql`
      query getClientesByContratista($id: ID!){
        contratista(id: $id){
          clientes {
            id
            estado
            centros{
              id
              estado
              transportistas {
                id
                documentos {
                  tipo
                  estado
                }
              }
              gestors {
                id
                documentos {
                  tipo
                  estado
                }
              }
              documentos{
                tipo
                estado
              }
            }
            
          }
        }
      }
    `;
  }

  getGestoresByContratista() {
    return gql`
      query getGestoresByContratista($id: ID!){
        contratista(id: $id){
          gestores {
            id
            nombre
            cif
            estado
            nombreContacto
            codigo
            nima
            domicilio{
              provincia
              ccaa
            }
            contratistaContacto {
              nombre
              mail
              contratista 
            }
            documentos {
              tipo
              enFecha
              caducado
              proximoCaduca
              estado
            }
          }
        }
      }
    `;
  }

  getGestoresYellowContratista() {
    return gql`
    query getGestoresByContratista($id: ID!){
      contratista(id: $id){
          gestores (
            where: {
              estado: "amarillo"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
      }
    `;
  }

  getGestoresGreenContratista() {
    return gql`
    query getGestoresByContratista($id: ID!){
      contratista(id: $id){
          gestores (
            where: {
              estado: "verde"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
      }
    `;
  }

  getGestoresRedContratista() {
    return gql`
    query getGestoresByContratista($id: ID!){
      contratista(id: $id){
          gestores (
            where: {
              estado: "rojo"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
      }
    `;
  }

  getTransportistasRedContratista() {
    return gql`
    query getTransportistasByContratista($id: ID!){
      contratista(id: $id){
          transportistas (
            where: {
              estado: "rojo"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
      }
    `;
  }

  getTransportistasYellowContratista() {
    return gql`
    query getTransportistasByContratista($id: ID!){
      contratista(id: $id){
          transportistas (
            where: {
              estado: "amarillo"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
      }
    `;
  }

  getTransportistasGreenContratista() {
    return gql`
    query getTransportistasByContratista($id: ID!){
      contratista(id: $id){
          transportistas (
            where: {
              estado: "verde"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
      }
    `;
  }

  getGestoresByContratistaDoughnout() {
    return gql`
      query getGestoresByContratista($id: ID!){
        contratista(id: $id){
          gestores {
            id
            estado
            documentos {
              tipo
              estado
            }
          }
        }
      }
    `;
  }

  getTransportistasByContratista() {
    return gql`
      query getGestoresByContratista($id: ID!){
        contratista(id: $id){
          transportistas {
            id
            nombre
            cif
            estado
            codigo
            nima
            direccion{
              provincia
              ccaa
            }
            contratistaContacto {
              nombre
              mail
              contratista 
            }
            nombreContacto
            documentos {
              tipo
              enFecha
              caducado
              proximoCaduca
              estado
            }
          }
        }
      }
    `;
  }

  getTransportistasByContratistaDoughnout() {
    return gql`
      query getGestoresByContratista($id: ID!){
        contratista(id: $id){
          transportistas {
            id
            estado
            
            documentos {
              tipo
              estado
            }
          }
        }
      }
    `;
  }


  getInstalacionesByContratista() {
    return gql`
      query getInstalacionesByContratista($id: ID!){
        contratista(id: $id){
          instalacions {
            id
            nombre
            cliente{
              id
              nombreComercial
            }
            direccion{
              tipoVia
              nombre
              numero
              ccaa
            }
            zonas {
              id
              nombre
            }
            campos {
              id
              nombre
              agrupacion {
                id
                nombre
              }
            }
            centro{
              documentos{
                tipo
                estado
              }
            }
          }
        }
      }
    `;
  }

  getAllDocumentosByContratista() {
    return gql`
      query getAllDocumentosByContratista($id: ID!){
        contratista(id: $id){
          documentos {
            tipo
            enFecha
            caducado
            proximoCaduca
          }
          gestores {
            id
            documentos {
              tipo
              enFecha
              caducado
              proximoCaduca
            }
          }
          centros {
            id
            documentos {
              tipo
              enFecha
              caducado
              proximoCaduca
            }
          }
          transportistas {
            id
            documentos {
              tipo
              enFecha
              caducado
              proximoCaduca
            }
          }
        }
      }
    `;
  }

  getAllContratistasName() {
    return gql`
      query getAllContratistas {
          contratistas(sort: "createdAt:DESC") {
            id
            nombreComercial
          }
        }
    `;
  }

  setIdContratista(id: any) {
    this.id = id;
  }

  getIdContratista() {
    let temp = this.id;
    this.clearIdContratista();
    return temp;
  }

  clearIdContratista() {
    this.id = undefined;
  }

  setContratistas(contratistas: any) {
    this.contratistas = contratistas;
  }

  getContratistas() {
    let temp = this.contratistas;
    this.clearContratistas();
    return temp;
  }

  clearContratistas() {
    this.contratistas = [];
  }

}
